import type { ApiPaginatedResponse, ApiResponse } from '@bcube/shared';
import { api } from '@/lib/api';

export interface HistoricalAuthor {
  name: string;
  avatarUrl?: string;
}

export interface HistoricalEditedField {
  key: string;
  newValue: string;
  oldValue: string;
}

export interface Historical {
  id: string;
  accountId: string;
  title: string;
  description?: string;
  action?: string;
  type?: 'proposta' | 'sistema' | 'manual' | 'conta';
  author?: HistoricalAuthor;
  editedFields?: HistoricalEditedField[];
  file?: { name?: string; url?: string; id?: string; key?: string };
  contacts?:
    | { id: string; name: string; type: string; contact: string }[]
    | { id: string; name: string; type: string; contact: string };
  metadata?: Record<string, unknown>;
  created_at: string;
}

export interface PaginatedHistoricalResponse {
  docs: Historical[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const historicalApi = {
  create: async (
    data: Omit<Historical, 'id' | 'created_at'>,
  ): Promise<{ success: boolean; id: string }> => {
    const { data: result } = await api.post<ApiResponse<{ id: string }>>(
      '/commercial/historicals',
      data,
    );
    return { success: true, id: result.data.id };
  },

  findByAccount: async (
    accountId: string,
    params?: { page?: number; limit?: number },
  ): Promise<PaginatedHistoricalResponse> => {
    const { data } = await api.get<ApiPaginatedResponse<Historical>>('/commercial/historicals', {
      params: { accountId, ...params },
    });
    return {
      docs: data.data,
      total: data.meta.total,
      page: data.meta.page,
      limit: data.meta.limit,
      totalPages: data.meta.pages,
    };
  },
};
